import React from "react";
import DTOGovtTaxARModal from "./DTOGovtTaxARModal";
import GovtTaxARModalPresenter from "./GovtTaxARModalPresenter";
import { useTranslation } from "react-i18next";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
}

const GovtTaxARModalController = ({
  isModalOpen,
  closeModal,
}: ModalInterface) => {
  const { t } = useTranslation();

  return (
    <div>
      <DTOGovtTaxARModal />

      <GovtTaxARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
      />
    </div>
  );
};

export default GovtTaxARModalController;
